import Login from './login.container';

export { FORM_NAME } from './login.container';

export default Login;



// WEBPACK FOOTER //
// ./src/login/index.js